import React, {PureComponent} from 'react';
import {Link} from 'react-router-dom';
import {getLinkPath} from 'app/utils/link_helper';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
export default class QuestionMark extends PureComponent {
    render() {
        return <div className="field__icon faq-button">
            <Link
                to={getLinkPath('/faq/my-hero-and-skins')}
                className="act faq-button__icon"
            >
                <SpriteIcon name="#svg-question" size={{height: 20, width: 20}}/>
            </Link>
        </div>;
    }
}
